import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, Table } from "react-bootstrap";
import Card from "../../../components/Card";
import { useNavigate, useParams } from "react-router-dom";
import { patchApiCallWithHeader, getApiCall } from "../../../service/httpCall";
import { API_USER_STATUS_UPDATE } from "../../../service/url";
import { ROUTES, BACKEND_API_BASE_URL } from "../../../utilities/constant";
import { toast } from 'react-toastify';
import { errorCheck } from "../auth/auth-utils";

const UserResetPassword = () => {
  const [buttonDisable, setButtonDisable] = useState(false);
  const [username, setUsername] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPasswordInputs, setShowPasswordInputs] = useState(false);
  const [enteredSamePasswords, setEnteredSamePasswords] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  

  const [passwordRules, setPasswordRules] = useState({
    length: false,
    upper: false,
    lower: false,
    number: false,
    special: false,
    space: true
  });

  const [passwordMatch, setPasswordMatch] = useState(null);

  useEffect(() => {
    const SELECTED_USER_ROUTE = `${API_USER_STATUS_UPDATE}/${id}`;
    getApiCall(SELECTED_USER_ROUTE, {})
    .then(getUserDataRecordSuccess)
    .catch(getUserDataError);
  }, []);

  const getUserDataRecordSuccess = (resp) => {
    if(resp){
      setUsername(resp.username);
    }
  }

  // useEffect(() => {
  //   if (toastProps) {
  //     setShowToast(true);
  //   }
  // }, [toastProps]);

  const handleValidateUsername = (e) => {
    e.preventDefault();
    setShowPasswordInputs(false);
    const ALL_USERS_ROUTE = `${BACKEND_API_BASE_URL}/v2/${ROUTES.USERS.LIST}`;
    if (!username.trim().length) {
      toast.error("Please add a valid username");
      return;
    }
    getApiCall(ALL_USERS_ROUTE, {})
      .then(getUserDataSuccess)
      .catch(getUserDataError);
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    setEnteredSamePasswords(false);

    if (!password.trim().length) {
      toast.error("Password Can't be blank");
      return;
    }

    if (password == selectedUser) {

      // setToastProps({
      //   message: "New Password Can't be same as Older Password.",
      //   type: "danger",
      toast.error("New Password Can't be same as Older Password.");
      return;
    }
    if (!confirmPassword.trim().length) {
      toast.error("Password Can't be blank");
      return;
    }

    if (password === confirmPassword) {
      const payload = { newPassword: confirmPassword };
      const SELECTED_USER_ROUTE = `${API_USER_STATUS_UPDATE}/${id}`;
      patchApiCallWithHeader(SELECTED_USER_ROUTE, payload)
          .then(handleUpdateUserPassword)
          .catch(getUserDataError);
    }
    if (password !== confirmPassword) {
      toast.error("Password and confirm password are different");
      return;
    }
  };

  const getUserDataSuccess = (resp) => {
    if (resp) {

      const filteredUserData = resp.filter((user) => {
        return user.username?.toLowerCase().trim() === username?.toLowerCase().trim()
      });


      if (filteredUserData.length < 1) {
        // setToastProps({
        //   message: "User not found. Try some different username.",
        //   type: "danger",
        toast.error("User not found. Try some different username.");
        return;
      }
      if (filteredUserData.length == 1) {
        setSelectedUser(filteredUserData[0].actual_password);
        // setToastProps({
        //   message: "User found.",
        //   type: "success",
        toast.success("User found.");
        setTimeout(() => {
          setShowPasswordInputs(true);
        }, 200);
      }
    }
  };

  const handleUpdateUserPassword = (resp) => {
    toast.success("Password Changed");
    setTimeout(() => {
      navigate("/users");
    }, 1000);
  }

  const getUserDataError = (err) => {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
      setShowPasswordInputs(false);
    } else {
      setButtonDisable(false);
      setShowPasswordInputs(false);
      toast.error(JSON.stringify(err));
    }
  };

  const validatePassword = (value) => {
    const rules = {
      length: value.length >= 8,
      upper: /[A-Z]/.test(value),
      lower: /[a-z]/.test(value),
      number: /[0-9]/.test(value),
      special: /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/+=~`]/.test(value),
      space: !/\s/.test(value),
    };

    setPasswordRules(rules);

    if (confirmPassword) {
      setPasswordMatch(value === confirmPassword);
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    let errors = [];

    // Rule checks
    if (value.length < 8) {
        errors.push("At least 8 characters");
    }
    if (!/[A-Z]/.test(value)) {
        errors.push("At least 1 uppercase letter");
    }
    if (!/[a-z]/.test(value)) {
        errors.push("At least 1 lowercase letter");
    }
    if (!/[0-9]/.test(value)) {
        errors.push("At least 1 number");
    }
    if (!/[!@#$%^&*(),.?\":{}|<>]/.test(value)) {
        errors.push("At least 1 special character");
    }
    if (/\s/.test(value)) {
        errors.push("No spaces allowed");
    }

    if (value.length === 0) {
        setPasswordError("");
    } else if (errors.length > 0) {
        setPasswordError(errors);
    } else {
        setPasswordError("");
    }

    if (confirmPassword) {
      setPasswordMatch(value === confirmPassword);
    }

    };
  return (
    <div>
      <Row>
        <Col xl="12" lg="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Reset Password</h4>
              </div>
            </Card.Header>
            <Card.Body>
              <form onSubmit={handleValidateUsername}>
                <div className="row">
                  <Form.Group className="col-md-6 form-group">
                    <Form.Label htmlFor="username">User Name:</Form.Label>
                    <Form.Control
                      type="text"
                      id="username"
                      required
                      placeholder="User Name"
                      value={username}
                      readOnly
                    />
                  </Form.Group>
                </div>
                <Button
                  type="submit"
                  variant="btn btn-primary"
                  disabled={buttonDisable}
                >
                  Continue &nbsp;
                  {buttonDisable ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    <></>
                  )}
                </Button>
              </form>

              {showPasswordInputs == true ? (
                <form
                  style={{ marginTop: "50px" }}
                  onSubmit={handleResetPassword}
                >
                  <div className="row">
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="username">
                        Enter new password:
                      </Form.Label>
                      {/* <Form.Control
                        type="password"
                        id="password"
                        placeholder="Password"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      /> */}
                      <div className="position-relative">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        id="password"
                        placeholder="Password"
                        required
                        value={password}
                        onChange={handlePasswordChange}
                      />

                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer"
                        }}
                      >
                        {showPassword ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
                      </span>
                      </div>
                        {Array.isArray(passwordError) && passwordError.length > 0 && (
                          <div style={{ color: "#dc3545", fontSize: "13px", marginTop: "5px" }}>
                           {passwordError.map((err, index) => (
                              <div key={index}>• {err}</div>
                            ))}
                          </div>
                        )}
                    </Form.Group>
                  </div>

                  <div className="row">
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="username">
                        Re-enter new password:
                      </Form.Label>
                      {/* <Form.Control
                        type="password"
                        id="confirm_password"
                        placeholder="Password"
                        required
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      /> */}
                      <div className="position-relative">
<Form.Control
  type={showConfirmPassword ? "text" : "password"}
  id="confirm_password"
  placeholder="Confirm Password"
  required
  value={confirmPassword}
  onChange={(e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    setPasswordMatch(password === value);
  }}
/>

<span
  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
  style={{
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer"
  }}
>
  {showConfirmPassword ? <i class="fa-solid fa-eye-slash"></i> : <i class="fa-solid fa-eye"></i>}
</span>
</div>

{confirmPassword && (
  <small className={passwordMatch ? "text-success" : "text-danger"}>
    {passwordMatch ? "✔ Passwords match" : "✖ Passwords do not match"}
  </small>
)}
                    </Form.Group>
                  </div>
                  <Button
                    type="submit"
                    variant="btn btn-primary"
                    disabled={buttonDisable}
                  >
                    Change Password &nbsp;
                    {buttonDisable ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      <></>
                    )}
                  </Button>
                </form>
              ) : null}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* <ToastNotification
        show_toast={showToast}
        set_show_toast={setShowToast}
        {...toastProps}
      /> */}
    </div>
  );
};

export default UserResetPassword;
